import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white daily-sales-box" }
const _hoisted_2 = {
  class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing",
  style: {"min-height":"205px"}
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "d-block mb-6 fs-13 text-uppercase fw-medium text-dark-emphasis" }, " Ganadores por Ciudad ", -1)
const _hoisted_4 = { class: "fw-black mb-12 lh-1 mt-30" }
const _hoisted_5 = { class: "chart" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_apexchart = _resolveComponent("apexchart")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("h1", _hoisted_4, _toDisplayString(_ctx.totalOtherWinners), 1),
      _createElementVNode("div", _hoisted_5, [
        (_openBlock(), _createBlock(_component_apexchart, {
          type: "bar",
          height: "150",
          id: "winnerPerCityChart",
          options: _ctx.winnerPerCityChart,
          series: _ctx.winners,
          key: _ctx.chartKey
        }, null, 8, ["options", "series"]))
      ])
    ])
  ]))
}